"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntroText = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var _constants = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Returns styled intro text. On desktop is centered.
 * Renders if `text` has thruthy value.
 */
const IntroText = ({
  text,
  className,
  isOverflowVisible = false
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const html = (0, _react.useMemo)(() => text ? (0, _utils.wrapInParagraph)((0, _sanitizeHtml.default)(text)) : null, [text]);
  if (!html) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTextWithHtml, {
    className: className,
    html: (0, _utils.wrapInParagraph)(html),
    isOverflowVisible: isOverflowVisible,
    testId: getTestId(_constants.INTRO_TEXT)
  });
};
exports.IntroText = IntroText;
//# sourceMappingURL=IntroText.js.map